//**auto-generated don't edit this code**//
import {ContractHttpClient} from '@esgi/contracts';
import {Observable} from 'rxjs';
import {InitRequest} from '../../../../../../../types/esgi.apigateway/api/controllers/v2/school-admins/pages/dashboard/init-request';
import {InitResultWithBaseResponse} from '../../../../../../../types/esgi.apigateway/api/controllers/v2/school-admins/pages/dashboard/init-result-with-base-response';

export function init(httpClient: ContractHttpClient) {
	return (inModel: InitRequest): Observable<InitResultWithBaseResponse> => {
		return httpClient.request<InitResultWithBaseResponse>(
			'GET',
			'/v2/school-admins/pages/dashboard/init',
			inModel,
		).asObservable();
	};
}
